import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import type { ReactNode } from "react";

interface AdminTab {
  label: string;
  content: ReactNode;
}

interface AdminTabSwitchProps {
  tabs: AdminTab[];
  /** Índice controlado (pra permitir trocar a aba via código, ex.: rodapé -> Histórico). */
  index?: number;
  defaultIndex?: number;
  onChange?: (index: number) => void;
}

export const AdminTabSwitch = ({ tabs, index, defaultIndex = 0, onChange }: AdminTabSwitchProps) => {
  const isControlled = index !== undefined;
  return (
    <Tabs
      variant="unstyled" size="sm"
      {...(isControlled ? { index } : { defaultIndex })}
      onChange={onChange} isLazy
    >
      <TabList display="inline-flex" gap={2} mb={6}>
        {tabs.map((tab) => (
          <Tab
            key={tab.label}
            fontSize="14px"
            fontWeight={500}
            px={5}
            py={2}
            borderRadius="50px"
            border="1px solid"
            borderColor="#009efb"
            color="#009efb"
            bg="transparent"
            _selected={{ bg: "#009efb", color: "white" }}
            _hover={{ bg: "#009efb", color: "white" }}
            _focus={{ boxShadow: "none" }}
            transition="all 0.2s"
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel key={tab.label} px={0} pt={0}>
            {tab.content}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};
